import styled from 'styled-components';
import { LinkButton } from './core';
import { RulesModal } from './RulesModal';
import { useState } from 'react';
import { PrivacyModal } from './PrivacyModal';
import { FeedbackModal } from './FeedbackModal';
import { Tube } from './layout/Tube';
import { LegalNotice } from './LegalNotice';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: 630px) {
    gap: 0.5rem;
  }
`;

export function FooterContent() {
  const [isRulesModalOpen, setIsRulesModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

  function handleCLoseFeedbackModal() {
    setIsFeedbackModalOpen(false);
  }

  function handleRulesClick() {
    setIsRulesModalOpen(true);
  }

  function handleRulesModalClose() {
    setIsRulesModalOpen(false);
  }

  function handlePrivacyClick() {
    setIsPrivacyModalOpen(true);
  }

  function handlePrivacyModalClose() {
    setIsPrivacyModalOpen(false);
  }

  function handleFeedbackClick() {
    setIsFeedbackModalOpen(true);
  }

  function handleCoffeeClick() {
    window.open('https://buymeacoffee.com/lovemedoku');
  }

  return (
    <Tube align="center">
      <Container>
        <LinkButton
          data-ref="'https://buymeacoffee.com/lovemedoku'"
          role="link"
          onClick={handleCoffeeClick}
        >
          Buy us a coffee ☕
        </LinkButton>
        <LinkButton onClick={handleRulesClick}>Rules</LinkButton>
        <LinkButton onClick={handleFeedbackClick}>Give us feedback</LinkButton>
        <LinkButton onClick={handlePrivacyClick}>Privacy policy</LinkButton>
      </Container>

      <LegalNotice />

      <RulesModal onClose={handleRulesModalClose} isOpen={isRulesModalOpen} />
      <PrivacyModal
        onClose={handlePrivacyModalClose}
        isOpen={isPrivacyModalOpen}
      />
      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={handleCLoseFeedbackModal}
      />
    </Tube>
  );
}
